import React, {Component} from 'react'

import styled from "styled-components"

import {DESKTOP_BREAKPOINT} from "manager/views/components/Settlement/constants"
import SettlementMaxWidth from "manager/views/components/Settlement/Common/SettlementMaxWidth"

const RedToastContainer = styled(SettlementMaxWidth)`
  background-color: #C53C3C
  @media screen and ${DESKTOP_BREAKPOINT} {
    position: absolute;
    right: 16px;
    height: 88px;
    width: 375px;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.3);
  }
`

const Text = styled.div`
  color: #FFFFFF;
  font-size: 16px;
  font-weight: bold;
  padding: 20px 20px;
`

class RedToast extends Component {
  render() {
    const {errorMessage} = this.props
    return (
      <RedToastContainer>
        <Text>{errorMessage}</Text>
      </RedToastContainer>
    )
  }
}

export default RedToast
